import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Card = function Card(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 11H10a2 2 0 00-2 2v13a2 2 0 002 2h20a2 2 0 002-2V13a2 2 0 00-2-2zM10 9a4 4 0 00-4 4v13a4 4 0 004 4h20a4 4 0 004-4V13a4 4 0 00-4-4H10z",
    fill: "#505F79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505F79",
    d: "M6 14h28v4H6z"
  }));
};
export default Card;